const errorMessages = {
    COMPANY_NAME_REQUIRED: 'The company name field is required.',
    WEBSITE_URL_REQUIRED: 'The website field is required.',
    NAME_REQUIRED: 'The name field is required.',
    EMAIL_REQUIRED: 'The email field is required.',
    PHONE_REQUIRED: 'The contact field is required.',
    // MOBILE_REQUIRED: 'The mobile field is required.',
    COUNTRY_REQUIRED: 'The country field is required.',
    INQUIRY_MSG_REQUIRED: 'The inquiry message field is required.',
    CONTACT_NUMBER_VALIDATION_MSG: 'Please enter valid contact number.',
    MOBILE_NUMBER_VALIDATION_MSG: 'Please enter valid mobile number.',
    PASSWORD_REQUIRED: 'The password field is required.',
    CONFIRM_PASSWORD_REQUIRED: 'The confirm password field is required.',
    STRONG_PASSWORD: 'Please provide strong password with 8+ characters, letters, numbers.',
    MATCH_PASSWORD: 'The password field did not matched.',
    INVALID_EMAIL: 'Please provide a valid Email',
    FIELD_REQUIRED: 'The field is required.',
    IN_VALID_FIELD_FORMAT: 'The field format is invalid.',
    MAX_LENGTH_EXCEEDED: 'The field must not be greater than 40 characters.',
    UNIQUE_MSG: 'The data has already been taken.',
    MAX_CHARACTERS_REACHED: 'The maximum character reached.',
    INVALID_FILE_SIZE:'The data size too large.',
    BOTH_EMAIL_OR_PHONE:'Please fill out either email or phone number.',
    MAX_LENGTH_20_EXCEEDED: 'The field must not be greater than 20 characters.',
    MAX_LENGTH_255_EXCEEDED: 'The field must not be greater than 255 characters.',
    MAX_LENGTH_100_EXCEEDED:'The field must not be greater than 100 characters.',
    MIN_LENGTH_100_REQUIRED: 'The field must be at least 100 characters.',
    MAX_LENGTH_50_EXCEEDED:'The field must not be greater than 50 characters.',
    MAX_LENGTH_150_EXCEEDED:'The field must not be greater than 150 characters.',
    MIN_LENGTH_2000_EXCEEDED:'The field must not be greater than 2000 characters.',
    MAX_LENGTH_80_EXCEEDED: 'The field must not be greater than 80 characters.',
    CREDIT_EXCEED: 'The credit cannot exceed total view credits.',
    CREDIT_TOTAL_NOT_MATCH: 'The total view credits must equal supplier & logistics credits.',
    MAX_LENGTH_25_EXCEEDED: 'The field must not be greater than 25 characters.',
};

export default errorMessages;
